export class SicherungssystemModel {
    public SicherungssystemID: number = 0;
    public RoofareaID: number = 0;
    public Bezeichnung: string = "";   
}

export interface SicherungssystemModelView {
    SicherungssystemID?: number
    RoofareaID?: number
    Bezeichnung: string   
    RoofareaBezeichnung?:string     
    DebitorID? :number
    DebitorNummer?: string   
    DebitorName? : string   
    StandortID? :number
    StandortBezeichnung? : string   
    ObjektID? :number
    BezeichnungBezeichnung?      : string   
} 